import { Card, CardContent } from '@daily/shared/components/Card';
import React from 'react';

export const CtaButtonContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="cta">
      <Card noBorder shadow="none">
        <CardContent>
          <div className="cta-inner">{children}</div>
        </CardContent>
      </Card>
      <style jsx>{`
        .cta {
          border-top: 1px solid var(--card-border);
          border-radius: 0;
        }
        .cta-inner {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
      `}</style>
    </div>
  );
};
